module.exports = __webpack_public_path__ + "7ffb58543a458d7bd343ae0cbc50d535.png";